import React, {Component} from 'react'
import objimag1 from './Assets/ObjImage1.png'
import objimag2 from './Assets/ObjImage2.png'
import './About.css'



class About extends Component{
    componentDidMount(){
        window.scrollTo(0,0)
    }
    render(){
        return(
            <div className="About">
                <div className="About_Landing">
                    <div className="Landing_Left AboutLand_Left">
                        <p className="About_Usss"> WHO WE ARE</p>
                    </div>
                    <div className="AboutLanding_Right contain">
                        <p className="About_Title">ABOUT US</p>
                        <p className="Who_We_Are">WHO WE ARE</p>
                        <p className="About_Details">The name of our organization is BLOSSOM AND 
                            FLOURISH CARE INITIATIVES, started ten years
                            ago with few persons rendering help to few 
                            orphans and widows around the neighbourhood.
                             It became upgraded and registered in 2020 
                             on full charity status covering North, South,
                              East and West regions of Nigeria with members 
                              internationally.</p>
                        <p className="About_Details">BLOSSOM AND FLOURISH CARE INITIATIVES is 
                            non-governmental in status, dedicated to provide 
                            humanitarian services to the most vulnerable individuals
                             and communities locally and internationally and 
                             geared towards reducing of : poverty, hunger,
                              societal conflicts, epidemics outbreak, illiteracy 
                              and primitiveness. </p>
                    </div>
                </div>
                <div className="About_Vision contain">
                        <p className="About_Title Vision_Title">VISION</p>
                        <p className="Card">Our vision is to operate a charitable
                            organization that will break the vicious
                            circle of poverty, restore dignity, 
                            and provide sustainable socio- economic development
                            to the most vulnerable individuals and 
                            communities globally.</p>
                </div>
                <div className="About_Mission contain">
                    <p className="Card">To focus in providing charitable services on: Humanitarianism,
                    Health, Environment, Religion, Farming and Education to rural 
                    communities and under-privilege individuals.</p>
                    <p className="About_Title Mission_Title">MISSION</p>
                </div>
                <div className="About_Corevalue">
                    <p className="CoreV_Title">CORE VALUES</p>
                    <div className="Core_Roles">
                        <div className="Core" data-aos="zoom-in-up">
                            <p className="Core_Title">	Transformation</p>
                            <p className="Core_Descr">We believe in urgent action, innovation, 
                            and the necessity of transformation—within the people,
                             community, world and our own organization.</p>
                        </div>
                        <div className="Core" data-aos="zoom-in-up">
                            <p className="Core_Title">Integrity</p>
                            <p className="Core_Descr">We are accountable to the people and partners we
                                 humbly serve, transparently, truthfully, honestly,
                                  reliably and trustfully; sharing our results,
                                   stories, and lessons.</p>
                        </div>
                        <div className="Core" data-aos="zoom-in-up">
                            <p className="Core_Title">Diversity</p>
                            <p className="Core_Descr">We know that by embracing differences,
                                actively including a variety of voices,
                                and joining together (Team work) we can
                                solve the world’s most complex problems.</p>
                        </div>
                    </div>
                    <div className="Core_Roles" data-aos="zoom-in-up">
                        <div className="Core">
                            <p className="Core_Title">	Excellence</p>
                            <p className="Core_Descr">We challenge ourselves to the highest 
                            level of learning and performance, tapping the best of the human
                             spirit and skills to create impact, Also ensure results are 
                             deliver on time/target and in the right way.</p>
                        </div>
                        <div className="Core" data-aos="zoom-in-up">
                            <p className="Core_Title">Equality</p>
                            <p className="Core_Descr">We believe in the equal value of every 
                            human being and the importance of respecting and honoring each 
                            individual; we know that change happens through people.</p>
                        </div>
                        <div className="Core" data-aos="zoom-in-up">
                            <p className="Core_Title">God fearing</p>
                            <p className="Core_Descr">We believe that whatever we are doing 
                            should be with fear of God and must be done in the right 
                            way or principles of God’</p>
                        </div>
                    </div>
                </div>
                <div className="About_Objectives">
                    <div className="ObjImages">
                        <div className="OBJImage_Cont">
                            <img src={objimag1} alt="OBJ_Image" />
                            <img src={objimag2} alt="OBJ_Image" />
                        </div>
                        <ul className="OBjectives_Details contain">
                            <p className="Obj_Title"> OBJECTIVES</p>
                            <li className="Obj_Detail">Our broad base objectives are:</li>
                            <li className="Obj_Detail">Advancement of religion</li>
                            <li className="Obj_Detail">Lessening the burdens of government</li>
                            <li className="Obj_Detail">Reducing neighborhood tensions/conflicts</li>
                            <li className="Obj_Detail">Elimination of prejudice and discrimination</li>
                            <li className="Obj_Detail">The advancement of health or the saving of lives</li>
                            <li className="Obj_Detail">Defense of human and civil rights secured by law</li>
                            <li className="Obj_Detail">Advancement of education, science and technology</li>
                            <li className="Obj_Detail">Relief of the poor, the distressed, or the underprivileged</li>
                            <li className="Obj_Detail">The advancement of citizenship and community development</li>
                            <li className="Obj_Detail">Combating community deterioration and juvenile delinquency</li> 
                        </ul>
                    </div>
                </div>
            </div>
        )
    }
}

export default About